import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ReportsService } from 'src/app/services/service.index';
import { PdfDialog } from './pdf.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Order } from '../order';
import { ResultsDialog } from './results.component';
import { SelectionModel } from '@angular/cdk/collections';
import { MatIconRegistry } from '@angular/material/icon';
import { UserService } from 'src/app/services/user.service';
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'history-dialog',
    templateUrl: 'history.component.html',
    styleUrls: ['./history.component.css'],
  })
  export class HistoryDialog {
    orders;
    patient;
    group;
    env = environment;
    constructor(
        public dialogRef: MatDialogRef<HistoryDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: ReportsService,
        private sanitizer: DomSanitizer,
        public dialog: MatDialog,
        private matIconRegistry: MatIconRegistry,
        private userService: UserService
        ) {
            this.orders = this.data.orders;
            if(this.data.patient.hasOwnProperty('nameSurname')){
              this.patient = this.data.patient;
            }else{
              this.patient = {
                age: this.orders[0].patientAge,
                birthdate: this.orders[0].patientBirthdate,
                nameSurname: this.orders[0].patientName,
                sex: this.orders[0].patientSex,
                fiscalCode: this.orders[0].patientFiscalCode,
                healthCode: this.orders[0].patientHealthCode

              }
            }
            this.group = this.data.group;
            this.matIconRegistry.addSvgIcon("doctor",
            this.sanitizer.bypassSecurityTrustResourceUrl("./assets/doctor.svg"));
        }

        pdf
        viewReport(order) {
          const obj = {
            groupId: this.group.id,
            groupType: 'report',
            reportType: 'report',
            generationType: this.userService.getSystemProperty('report.generation')
          }; 
          obj['reportRequest']= [{orderId: order.orderId,
              lastReportId: order.lastReportId,
              orderDate: order.orderDate,
              source: order.source,
            patientId: order.patientId}];
            this.service.getReports(obj).subscribe( (resp) => {
              // const fileURL = URL.createObjectURL(resp);
              // window.open(fileURL, '_blank');
              this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(resp));
              this.dialog.open(PdfDialog, {
                width: '80%',
                height: '89%',
                data: this.pdf
              });
            });
          }

          groupsId;
          results;
        viewResults(order: Order) {
            this.service.getResults(order).subscribe( (resp) => {
                this.groupsId = [... new Set(resp.map(res => res.groupId))]
                // const fileURL = URL.createObjectURL(resp);
                // window.open(fileURL, '_blank');
                this.results = this.processResults(resp);
                //this.open(content);
                this.dialog.open(ResultsDialog, {
                    data: {results: this.results,
                        patient: {
                            name: order.patientName,
                            sex: order.patientSex,
                            dni: order.patientFiscalCode,
                            birthdate: order.patientBirthdate
                        }}
                });
            });        
        }

        viewReports() {
          const obj = {
            groupId: this.group.id,
            groupType: 'report',
            reportType: 'report',
            generationType: this.userService.getSystemProperty('report.generation')
          }; 
          obj['reportRequest'] = this.selection.selected.map(order => {
            const obj = {orderId: order.orderId,
                        lastReportId: order.lastReportId == -1 ? null : order.lastReportId,
                       orderDate: order.orderDate,
                       source: order.source,
                       patientId: order.patientId};
      
            return obj;
          });
      
          this.service.getReports(obj).subscribe( (resp) => {
            if (resp){
              const fileURL = URL.createObjectURL(resp);
              //window.open(fileURL, '_blank');
              this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
              this.dialog.open(PdfDialog, {
                width: '80%',
                height: '89%',
                data: this.pdf
              });
            }
          });
        }

        processResults(results) {
            let rootId = '';
            for ( let i = 0; i < results.length; ++i) {
              if (results[i].testId != results[i].testRootId && results[i].testRootId != rootId) {
                rootId = results[i].testRootId;
                results.splice(i, 0 , {testDescription: results[i].testRootDescription, isBold: true, groupId: results[i].groupId});
              } else if (results[i].testId == results[i].testRootId) {
                results[i].isBold = true;
              }
            }
            return results;
          }


    selection = new SelectionModel<any>(true, []);

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.orders.filter(order=> order.reportState > 0).length;
      return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
      if(this.isAllSelected()){
        this.selection.clear()
      }
      else{
        this.orders.forEach(row => {
          if(row.reportState > 0)
            this.selection.select(row)
        });
      }
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: any): string {
      
      if (!row) {
        return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
      }
      return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    }

    selectOrder(order){
      if(order.reportState > 0){
        this.selection.toggle(order);
      }
    }

  }